<template>
  <v-alert :value="showAlertDialog" :type="'error'">
    <h1>{{'Status: ' + alertMessage.status + ' ('+ 'Path: ' + alertMessage.path + ') '}}</h1>
    <p>{{'Message: ' + alertMessage.message}}</p>
  </v-alert>
</template>
<script>
/* eslint-disable */
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("alert", ["showAlertDialog", "alertMessage"])
  }
};
</script>

